import { NgModule } from "@angular/core";
import { FooterModule } from "./footer/footer.module";
import { EqualValidator } from "./directives/equal-validator.directive";
import { AlertModule } from "./alert/alert.module";
import { CircleSpinnerModule } from "./circle-spinner/circle-spinner.module";
import { TranslateModule } from "@ngx-translate/core";
import { BackButtonDirective } from "./directives/backbutton.directive";

@NgModule({
  declarations: [EqualValidator, BackButtonDirective],
  exports: [
    EqualValidator,
    FooterModule,
    AlertModule,
    CircleSpinnerModule,
    TranslateModule,
    BackButtonDirective,
  ],
})
export class SharedModule {}
